import { render, staticRenderFns } from "./FuncaoSelect.vue?vue&type=template&id=45532378"
import script from "./FuncaoSelect.vue?vue&type=script&lang=js"
export * from "./FuncaoSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports